const tvList = [
    {
      description: "This is a great TV",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/tv-pic.png',
      model: "Samsung",
      sku: "123456",
      tag: "TV & Home Theater",
      alt: "tv image",
      id: 0
    },
  
    {
      description: "This is a great  TV",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/tv-pic.png',
      model: "Zennith",
      sku: "123456",
      tag: "TV & Home Theater",
      alt: "tv image",
      id: 1
    },
    {
      description: "This is a great TV",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/tv-pic.png',
      model: "RCA",
      sku: "123456",
      tag: "TV & Home Theater",
      alt: "tv image",
      id: 2
    },
    {
      description: "This is a great TV",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/tv-pic.png',
      model: "Sony",
      sku: "123456",
      tag: "TV & Home Theater",
      alt: "tv image",
      id: 3
    },
    {
      description: "This is a great TV",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/tv-pic.png',
      model: "Panasonic",
      sku: "123456",
      tag: "TV & Home Theater",
      id: 4
    },
    {
      description: "This is a great TV",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/tv-pic.png',
      model: "Magnavox",
      sku: "123456",
      tag: "TV & Home Theater",
      alt: "tv image",
      id: 5
    }
  ];
  
  const computerList = [
    {
      description: "This is a great computer",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/computer-pic.png',
      model: "Commodore 64",
      sku: "123456",
      tag: "Desktops & Laptops",
      alt: "computer image",
      id: 0
    },
  
    {
      description: "This is a great computer",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/computer-pic.png',
      model: "Texas Instruments TI-99/4A",
      sku: "123456",
      tag: "Desktops & Laptops",
      alt: "computer image",
      id: 1
    },
    {
      description: "This is a great computer",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/computer-pic.png',
      model: "Tandy TRS-80",
      sku: "123456",
      tag: "Desktops & Laptops",
      alt: "computer image",
      id: 2
    },
    {
      description: "This is a great computer",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/computer-pic.png',
      model: "Apple IIe",
      sku: "123456",
      tag: "Desktops & Laptops",
      alt: "computer image",
      id: 3
    },
    {
      description: "This is a great computer",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/computer-pic.png',
      model: "Timex Sinclair 1000",
      sku: "123456",
      tag: "Desktops & Laptops",
      alt: "computer image",
      id: 4
    },
    {
      description: "This is a great computer",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/computer-pic.png',
      model: "IBM PCjr",
      sku: "123456",
      tag: "Desktops & Laptops",
      alt: "computer image",
      id: 5
    }
  ];
  
  const cameraList = [
    {
      description: "This is a great camera",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/camera-pic.png',
      model: "Fuji GW690III",
      sku: "123456",
      tag: "Cameras & Videocameras",
      alt: "camera image",
      id: 0
    },
  
    {
      description: "This is a great camera",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/camera-pic.png',
      model: "Polaroid SX-70",
      sku: "123456",
      tag: "Cameras & Videocameras",
      alt: "camera image",
      id: 1
    },
    {
      description: "This is a great camera",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/camera-pic.png',
      model: "Rollei 35 S",
      sku: "123456",
      tag: "Cameras & Videocameras",
      alt: "camera image",
      id: 2
    },
    {
      description: "This is a great camera",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/camera-pic.png',
      model: "Plaubel Makina W67",
      sku: "123456",
      tag: "Cameras & Videocameras",
      alt: "camera image",
      id: 3
    },
    {
      description: "This is a great camera",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/camera-pic.png',
      model: "Kiev 88",
      sku: "123456",
      tag: "Cameras & Videocameras",
      alt: "camera image",
      id: 4
    },
    {
      description: "This is a great camera",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/camera-pic.png',
      model: "Pentax 67",
      sku: "123456",
      tag: "Cameras & Videocameras",
      alt: "camera image",
      id: 5
    }
  ];
  
  const applianceList = [
    {
      description: "Winter has come at last",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/fridge-pic.png',
      model: "GE",
      sku: "123456",
      tag: "Appliances",
      alt: "appliance image",
      id: 0
    },
  
    {
      description: "The Ice Man cometh",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/fridge-pic.png',
      model: "LG",
      sku: "123456",
      tag: "Appliances",
      alt: "appliance image",
      id: 1
    },
    {
      description: "Tonight's forecast: a freeze is coming",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/fridge-pic.png',
      model: "Samsung",
      sku: "123456",
      tag: "Appliances",
      alt: "appliance image",
      id: 2
    },
    {
      description: "My condition has left me cold to your pleas of mercy",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/fridge-pic.png',
      model: "Hotpoint",
      sku: "123456",
      tag: "Appliances",
      alt: "appliance image",
      id: 3
    },
    {
      description: "It's a cold town",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/fridge-pic.png',
      model: "Better Catch Me",
      sku: "123456",
      tag: "Appliances",
      alt: "appliance image",
      id: 4
    },
    {
      description: "Let's kick some ice",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/fridge-pic.png',
      model: "Vance Refrigeration",
      sku: "123456",
      tag: "Appliances",
      alt: "appliance image",
      id: 5
    }
  ];
  
  const audioList = [
    {
      description: "This is a great bluetooth speaker!",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/audio-pic.png',
      model: "Linn Products",
      sku: "123456",
      tag: "Audio",
      alt: "audio image",
      id: 0
    },
  
    {
      description: "This is a great bluetooth speaker!",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/audio-pic.png',
      model: "Thorens",
      sku: "123456",
      tag: "Audio",
      alt: "audio image",
      id: 1
    },
    {
      description: "This is a great bluetooth speaker!",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/audio-pic.png',
      model: "Technics",
      sku: "123456",
      tag: "Audio",
      alt: "audio image",
      id: 2
    },
    {
      description: "This is a great bluetooth speaker!",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/audio-pic.png',
      model: "Garrard",
      sku: "123456",
      tag: "Audio",
      alt: "audio image",
      id: 3
    },
    {
      description: "This is a great bluetooth speaker!",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/audio-pic.png',
      model: "Sansui",
      sku: "123456",
      tag: "Audio",
      alt: "audio image",
      id: 4
    },
    {
      description: "This is a great bluetooth speaker!",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/audio-pic.png',
      model: "Rega",
      sku: "123456",
      tag: "Audio",
      alt: "audio image",
      id: 5
    }
  ];
  
  const gadgetsList = [
    {
      description: "This is a great gadget",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/palm-pilot.png',
      model: "Apple iPhone",
      sku: "123456",
      tag: "Gadgets",
      alt: "gadget image",
      id: 0
    },
  
    {
      description: "This is a great gadget",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/palm-pilot.png',
      model: "Netgear SPH200W Wi-Fi Skype Phone",
      sku: "123456",
      tag: "Gadgets",
      alt: "gadget image",
      id: 1
    },
    {
      description: "This is a great gadget",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/palm-pilot.png',
      model: "Palm Centro",
      sku: "123456",
      tag: "Gadgets",
      alt: "gadget image",
      id: 2
    },
    {
      description: "This is a great gadget",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/palm-pilot.png',
      model: "Samsung P2",
      sku: "123456",
      tag: "Gadgets",
      alt: "gadget image",
      id: 3
    },
    {
      description: "This is a great gadget",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/palm-pilot.png',
      model: "FlyTech Dragonfly",
      sku: "123456",
      tag: "Gadgets",
      alt: "gadget image",
      id: 4
    },
    {
      description: "This is a great gadget",
      //src: 'https://via.placeholder.com/100',
      src: '../../../img/palm-pilot.png',
      model: "Iomega eGo Portable Hard Drive",
      sku: "123456",
      tag: "Gadgets",
      alt: "gadget image",
      id: 5
    }
  ];
  
  export { gadgetsList, audioList, tvList, applianceList, computerList, cameraList }
  